// extracted by mini-css-extract-plugin
export default {"roomThumbnail":"RoomsList_roomThumbnail__HHgKY"};